import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

import { FORM_NAME, STREAM } from './fields';

export const MicrophoneVolumeLevel = () => {
  const { [STREAM]: stream } = useSelector(getFormValues(FORM_NAME));
  const [volumeLevel, setVolumeLevel] = useState(0);

  useEffect(() => {
    if (stream instanceof MediaStream === false) {
      return;
    }

    const audioContext = new AudioContext();
    const scriptProcessorNode = audioContext.createScriptProcessor(2048, 1, 1);
    scriptProcessorNode.connect(audioContext.destination);

    const analyserNode = audioContext.createAnalyser();
    analyserNode.smoothingTimeConstant = 0.8;
    analyserNode.fftSize = 1024;
    analyserNode.connect(scriptProcessorNode);

    const mediaStreamAudioSourceNode = audioContext.createMediaStreamSource(stream);

    mediaStreamAudioSourceNode.connect(analyserNode);

    const audioProcessListener = function () {
      const array = new Uint8Array(analyserNode.frequencyBinCount);

      analyserNode.getByteFrequencyData(array);

      const values = array.reduce((previous, current) => previous + current, 0);

      setVolumeLevel(Math.round(values / array.length));
    };

    scriptProcessorNode.addEventListener('audioprocess', audioProcessListener);

    return () => {
      scriptProcessorNode.removeEventListener('audioprocess', audioProcessListener);
    };
  }, [stream]);

  if (stream instanceof MediaStream === false) {
    return null;
  }

  return (
    <div className="microphone-volume-level">
      {[...Array(10).keys()].map((volumeBar) => (
        <div key={volumeBar} className={volumeLevel > volumeBar * 10 + 10 ? 'active' : ''} />
      ))}
    </div>
  );
};
